import {ID,Response} from "../../../../../_metronic/helpers";

export type Post = {
    id?: ID,
    title?: string,
    shortDescription?: string,
    description?: string,
    content?: string,
    postType?: PostType,
    keys?: string,
    userID?: number,
    dateTime?: Date,
    lastUpdate?: Date,
    picName?: string,
    dateString?: string,
    postVsCategoriesList ? : number[]
    unReadComments?: number,
    url?:string,
    isTag:boolean
}
export type UsersQueryResponse = Response<Array<Post>>
export const initialPost : Post = {
    title : '',
    dateString : '',
    userID : 0 ,
    content : '',
    keys :'',
    description : '',
    isTag: false
}
export type PostComments = {
    comment: string,
    name: string,
    dateTime:Date,
    parentId: number,
    isPublish: boolean,
    postId: number,
    isReade: boolean,
    dateString: string
    id: ID
}
export enum PostType  {
    Publish ,
    Draft,
    PendingForAccept
}
export type AddPostComment = {
    comment : string,
    parent : number
}
